const providerMap = {};

export const DISCONNECTED = 'DISCONNECTED_FROM_PROVIDER';

function clear(id) {
  const provider = providerMap[id];
  if (provider.consumers) {
    /* eslint-disable prefer-arrow-callback */
    provider.consumers.forEach(function callback(getData) {
      // we want to preserve any `this`
      getData(DISCONNECTED);
    });
    /* eslint-enable */
  }
  delete providerMap[id];
}

export function provide(id, data) {
  if (!providerMap[id]) {
    providerMap[id] = {
      data,
      consumers: [],
    };
  }

  const provider = providerMap[id];

  if (provider.consumers) {
    /* eslint-disable prefer-arrow-callback */
    provider.consumers.forEach(function callback(getData) {
      // we want to preserve any `this`
      getData(data);
    });
    /* eslint-enable */
  }

  provider.data = data;
  return () => clear(id);
}

export function consume(id, consumeFn) {
  const provider = providerMap[id];
  if (!provider) {
    console.warn('No provider found with ID', id); // eslint-disable-line no-console
    return () => {};
  }

  consumeFn(provider.data);
  provider.consumers.push(consumeFn);
  return () => provider && provider.consumers.filter(fn => fn !== consumeFn);
}
